export default "__VITE_PUBLIC_ASSET__3f9aa40f__"